export default __webpack_public_path__ + "static/guardian-daa58a82a252a76ac413d7a7c08df2d3.svg";